import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate';
import { migrateSecureLsState } from './migrateSecureLs';
import { PERSIST_PATHS, safeSetState, shrinkStoredState } from './persist';
import UserApp from './user/app/';
import UserAuth from './user/auth/';
import ClubApp from './club/app/';
import ClubAuth from './club/auth/';
import GeneralApp from './app/';
import AdminApp from './admin/app';

const STORAGE_KEY = 'vuex';

// Stände aus der SecureLS-Zeit einmalig in Klartext-JSON umwandeln (kein Logout)
migrateSecureLsState(window.localStorage, STORAGE_KEY);
// Alte, komplette Stände auf die gespeicherten Pfade kürzen (siehe persist.js)
shrinkStoredState(window.localStorage, STORAGE_KEY);

Vue.use(Vuex)

export default new Vuex.Store ({

    plugins: [
        createPersistedState({
            key: STORAGE_KEY,
            paths: PERSIST_PATHS,
            setState: safeSetState,
        }),
    ],
    modules: {
        UserApp,
        UserAuth,
        ClubApp,
        ClubAuth,
        GeneralApp,
        AdminApp,

    },
});
